import ajax from '../utils/ajax'

export default {
    multiWords: keyword => ajax.get("/api/ports/multiWords", {params: {keyword: keyword || ""}}),
};
